import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RecaptchaModule } from "ng-recaptcha";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { DataTablesModule } from "angular-datatables";
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxCurrencyModule } from "ngx-currency";
import { CommonModule } from '@angular/common';
import * as PlotlyJS from 'plotly.js-dist-min';
import { PlotlyModule } from 'angular-plotly.js';
PlotlyModule.plotlyjs = PlotlyJS;


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { AdministradorComponent } from './administrador/administrador.component';
import { HeaderComponent } from './plantillas/header/header.component';
import { FooterComponent } from './plantillas/footer/footer.component';

import { ReactiveFormsModule, FormsModule} from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DirectorioComponent } from './directorio/directorio.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { FuentesComponent } from './directorio/fuentes/fuentes.component';
import { VariablesfiviComponent } from './directorio/variablesfivi/variablesfivi.component';
import { VariableschvComponent } from './directorio/variableschv/variableschv.component';
import { NavbarComponent } from './plantillas/navbar/navbar.component';
import { NuevafuenteComponent } from './directorio/fuentes/nuevafuente/nuevafuente.component';
import { EditarfuenteComponent } from './directorio/fuentes/editarfuente/editarfuente.component';
import { CargandoComponent } from './plantillas/cargando/cargando.component'
import { CargandoService } from './plantillas/cargando/cargando.service';
import { ActivacionComponent } from './directorio/fuentes/activacion/activacion.component';
import { AppServiceService } from './servicios/AppService.service';
import { UsuariochvComponent } from './usuarios/usuariochv/usuariochv.component';
import { UsuariofiviComponent } from './usuarios/usuariofivi/usuariofivi.component';
import { UsuariodaneComponent } from './usuarios/usuariodane/usuariodane.component';
import { EditarusuarioComponent } from './usuarios/editarusuario/editarusuario.component';
import { AdminvariableschvComponent } from './directorio/variableschv/adminvariableschv/adminvariableschv.component';
import { AdminvariablesfiviComponent } from './directorio/variablesfivi/adminvariablesfivi/adminvariablesfivi.component';
import { CaratulaComponent } from './Fuentes/caratula/caratula.component';
import { CambioclaveComponent } from './plantillas/cambioclave/cambioclave.component';
import { CarguemComponent } from './Fuentes/carguem/carguem.component';
import { ParametricasComponent } from './parametricas/parametricas.component';
import { SuperintendenciaComponent } from './parametricas/superintendencia/superintendencia.component';
import { TipoentidadComponent } from './parametricas/tipoentidad/tipoentidad.component';
import { TipocreditoComponent } from './parametricas/tipocredito/tipocredito.component';
import { NovedadesComponent } from './Fuentes/novedades/novedades.component';
import { ConsultareportComponent } from './Fuentes/consultareport/consultareport.component';
import { VariableComponent } from './parametricas/variable/variable.component';
import { CalendarioComponent } from './calendario/calendario.component';
import { CalendariochvComponent } from './calendario/calendariochv/calendariochv.component';
import { CalendariofiviComponent } from './calendario/calendariofivi/calendariofivi.component';
import { CarguemsuperComponent } from './Fuentes/carguemsuper/carguemsuper.component';
import { CarguemfiviComponent } from './Fuentes/carguemfivi/carguemfivi.component';
import { ParametricaschvComponent } from './parametricas/parametricaschv/parametricaschv.component';
import { ParametricasfiviComponent } from './parametricas/parametricasfivi/parametricasfivi.component';
import { AnalisisComponent } from './analisis/analisis.component';
import { AnalisischvComponent } from './analisis/analisischv/analisischv.component';
import { AnalisisfiviComponent } from './analisis/analisisfivi/analisisfivi.component';
import { AdmininfoComponent } from './admininfo/admininfo.component';
import { AdmininfchvComponent } from './admininfo/admininfchv/admininfchv.component';
import { AdmininffiviComponent } from './admininfo/admininffivi/admininffivi.component';
import { ConsultarinforchvComponent } from './admininfo/admininfchv/consultarinforchv/consultarinforchv.component';
import { CargueminformchvComponent } from './admininfo/admininfchv/cargueminformchv/cargueminformchv.component';
import { CrearnovedadComponent } from './admininfo/admininfchv/crearnovedad/crearnovedad.component';
import { ActivarcargueComponent } from './admininfo/admininfchv/activarcargue/activarcargue.component';
import { ConsultarinfofiviComponent } from './admininfo/admininffivi/consultarinfofivi/consultarinfofivi.component';
import { CargueminformfiviComponent } from './admininfo/admininffivi/cargueminformfivi/cargueminformfivi.component';
import { CrearnovedadfiviComponent } from './admininfo/admininffivi/crearnovedadfivi/crearnovedadfivi.component';
import { ActivarcarguefiviComponent } from './admininfo/admininffivi/activarcarguefivi/activarcarguefivi.component';
import { OperativoComponent } from './operativo/operativo.component';
import { OperativochvComponent } from './operativo/operativochv/operativochv.component';
import { OperativofiviComponent } from './operativo/operativofivi/operativofivi.component';
import { OperativofivitrimestralComponent } from './operativo/operativofivitrimestral/operativofivitrimestral.component';
import { IndicadoresComponent } from './indicadores/indicadores.component';
import { IndicadoreschvComponent } from './indicadores/indicadoreschv/indicadoreschv.component';
import { IndicadoresfiviComponent } from './indicadores/indicadoresfivi/indicadoresfivi.component';
import { IndicadoresfivitrimestralComponent } from './indicadores/indicadoresfivitrimestral/indicadoresfivitrimestral.component';
import { CuadrosSalidaComponent } from './cuadrosSalida/cuadrosSalida.component';
import { CuadrosSalidaChvComponent } from './cuadrosSalida/cuadrosSalidaChv/cuadrosSalidaChv.component';
import { CuadrosSalidaFiviComponent } from './cuadrosSalida/cuadrosSalidaFivi/cuadrosSalidaFivi.component';
import { InterceptorService } from './servicios/interceptorService/interceptor.service';




@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AdministradorComponent,
    HeaderComponent,
    FooterComponent,
    DirectorioComponent,
    UsuariosComponent,
    FuentesComponent,
    VariablesfiviComponent,
    VariableschvComponent,
    NavbarComponent,
    NuevafuenteComponent,
    EditarfuenteComponent,
    CargandoComponent,
    ActivacionComponent,
    UsuariochvComponent,
    UsuariofiviComponent,
    UsuariodaneComponent,
    EditarusuarioComponent,
    AdminvariableschvComponent,
    AdminvariablesfiviComponent,
    CaratulaComponent,
    CambioclaveComponent,
    CarguemComponent,
    ParametricasComponent,
    SuperintendenciaComponent,
    TipoentidadComponent,
    TipocreditoComponent,
    NovedadesComponent,
    ConsultareportComponent,
    VariableComponent,
    CalendarioComponent,
    CalendariochvComponent,
    CalendariofiviComponent,
    CarguemsuperComponent,
    CarguemfiviComponent,
    ParametricaschvComponent,
    ParametricasfiviComponent,
    AnalisisComponent,
    AnalisischvComponent,
    AnalisisfiviComponent,
    AdmininfoComponent,
    AdmininfchvComponent,
    AdmininffiviComponent,
    ConsultarinforchvComponent,
    CargueminformchvComponent,
    CrearnovedadComponent,
    ActivarcargueComponent,
    ConsultarinfofiviComponent,
    CargueminformfiviComponent,
    CrearnovedadfiviComponent,
    ActivarcarguefiviComponent,
    OperativoComponent,
    OperativochvComponent,
    OperativofiviComponent,
    OperativofivitrimestralComponent,
    IndicadoresComponent,
    IndicadoreschvComponent,
    IndicadoresfiviComponent,
    IndicadoresfivitrimestralComponent,
    CuadrosSalidaComponent,
    CuadrosSalidaChvComponent,
    CuadrosSalidaFiviComponent
   ],
  imports: [
    BrowserModule,
    RecaptchaModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(), // ToastrModule added
    DataTablesModule,
    NgxPaginationModule,
    NgxCurrencyModule,
    CommonModule,
    PlotlyModule

  ],
  providers: [
    CargandoService,
    AppServiceService,
    {
      provide: HTTP_INTERCEPTORS,  // Aquí registras el interceptor
      useClass: InterceptorService,
      multi: true  // Esto asegura que puedas tener múltiples interceptores si es necesario
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
